"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _theme = require("../../theme");

var _default = {
  MuiChip: {
    root: {
      fontSize: "0.75rem",
      height: "1.5rem",
      maxWidth: "11rem",
      overflow: "hidden",
      paddingLeft: _theme.spacing[3],
      paddingRight: _theme.spacing[3],
      textOverflow: "ellipsis",
      whiteSpace: "nowrap"
    },
    sizeSmall: {
      paddingLeft: 0,
      paddingRight: 0
    }
  }
};
exports.default = _default;